// styles.js
// Shared styles for SellerRetry components

import { COLORS } from '../../constants';

export const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    padding: '20px'
  },

  container: {
    background: 'white',
    borderRadius: '20px',
    padding: '40px',
    maxWidth: '500px',
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px'
  },

  icon: {
    fontSize: '4rem',
    animation: 'spin-gentle 3s ease-in-out infinite'
  },

  title: {
    color: COLORS.text?.primary || '#333',
    fontSize: '1.8rem',
    fontWeight: 700,
    margin: 0
  },

  message: {
    color: COLORS.text?.secondary || '#666',
    fontSize: '1.1rem',
    lineHeight: 1.6,
    margin: 0
  },

  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    margin: '20px 0',
    padding: '20px',
    background: 'linear-gradient(135deg, #fff7ed, #fef3c7)',
    borderRadius: '12px',
    border: '1px solid #fed7aa'
  },

  infoItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    color: COLORS.text?.primary || '#333',
    fontWeight: 500
  },

  infoIcon: {
    fontSize: '1.3rem',
    width: '24px',
    textAlign: 'center'
  },

  button: {
    padding: '16px 32px',
    background: `linear-gradient(135deg, ${COLORS.primary}, ${COLORS.primaryDark})`,
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '1.1rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    boxShadow: '0 4px 15px rgba(206, 17, 38, 0.3)'
  },

  buttonHover: {
    background: `linear-gradient(135deg, ${COLORS.primaryDark}, #8b0000)`,
    transform: 'translateY(-2px)',
    boxShadow: '0 8px 25px rgba(206, 17, 38, 0.4)'
  },

  buttonIcon: {
    fontSize: '1.2rem'
  },

  // Mobile responsive styles
  '@media (max-width: 768px)': {
    container: {
      padding: '30px 20px',
      margin: '20px'
    },
    title: {
      fontSize: '1.5rem'
    },
    message: {
      fontSize: '1rem'
    }
  }
};

// CSS keyframes for animations
export const keyframes = `
  @keyframes spin-gentle {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(90deg); }
    50% { transform: rotate(180deg); }
    75% { transform: rotate(270deg); }
  }
`;

// Media queries for responsive design
export const mediaQueries = {
  mobile: '@media (max-width: 768px)'
};